import React, { FC } from 'react'

import {
  AppIconSizes,
  AppIconVariants,
  BasicAppIconProps
} from '@inno-ui/app-icons'
import { IconSizes } from '@inno-ui/icons'
import { BasicIconProps } from '@inno-ui/icons/lib/Icons.types'
import cn from 'classnames'

import styles from './SidebarAppButton.module.scss'
import { SidebarAppButtonProps } from './SidebarAppButton.types'

const isBasicIcon = (
  icon: FC<BasicAppIconProps> | FC<BasicIconProps>
): icon is FC<BasicIconProps> =>
  (icon as { $$typeof?: symbol }).$$typeof === Symbol.for('react.forward_ref')

export const SidebarAppButton: FC<SidebarAppButtonProps> = ({
  icon: Icon,
  label,
  onClick,
  isActive
}) => {
  const renderIcon = () => {
    if (typeof Icon === 'string') {
      return <img src={Icon} width={24} height={24} className={styles.icon} />
    }
    if (isBasicIcon(Icon)) {
      return <Icon size={IconSizes.Size24} />
    }
    return <Icon variant={AppIconVariants.Full} size={AppIconSizes.Size24} />
  }

  return (
    <button
      className={cn(styles.sidebarAppButton, {
        [styles.active]: isActive
      })}
      type='button'
      aria-label={label}
      aria-pressed={Boolean(isActive)}
      title={label}
      onClick={onClick}
    >
      <span className={styles.icon} aria-hidden='true'>
        {renderIcon()}
      </span>
      <span className={styles.label}>{label}</span>
    </button>
  )
}
